import { ApiService }            from '../../app-lite/api/api.service';
import { CompanyIntegrationsModel } from '../../app-lite/companies/models/company.integrations';
import { SessionService }        from '../../app-lite/sessions/session.service';

import StripeSettingsHtml from './stripe.settings.html';

export function StripeStates (
  $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'StripeSettingsCtrl',
    name       : 'app.stripe-settings',
    templateUrl: StripeSettingsHtml,
    url        : '/stripe-settings',
    resolve    : {
      session : ( sessionObjAPI : SessionService ) : ng.IPromise<any>                      => sessionObjAPI.refresh(),
      settings: ( workshopAPI : ApiService )          : ng.IPromise<CompanyIntegrationsModel> => workshopAPI.get('/company_integrations')
    }
  });
};
